module.exports = __webpack_public_path__ + "img/fastcharger-in-progress-semipublic.fee409f1.svg";